import ClipLoader from "react-spinners/ClipLoader";

const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
};

function Spinner() {

    return (
        <div>
            <ClipLoader
                color="#FBE440"
                loading="true"
                size={60}
                override={override}
            />
        </div>
    );
}

export default Spinner;